import React, { useContext, useState } from 'react';

import classnames from 'classnames';
import { ClipboardCheck, Inbox } from 'lucide-react';

import Pill, { DefaultPillStyles } from 'common/common/Pill';
import { CompanyContext } from 'common/containers/CompanyContainer';
import { LocationContext } from 'common/containers/RouterContainer';
import Link from 'common/Link';
import UpsellModal from 'common/modals/UpsellModal';
import AdminSidebarSection from 'common/subdomain/admin/AdminSidebarSection';
import AdminSidebarSectionItem from 'common/subdomain/admin/AdminSidebarSectionItem';
import CountBadge from 'common/ui/CountBadge';

import type { Company } from 'common/api/endpoints/companies';

import 'css/components/subdomain/admin/_AdminSidebarMenuSection.scss';

type Props = {
  inboxTotalItemCount?: number;
};

const AdminSidebarMenuSection = (props: Props) => {
  const { inboxTotalItemCount } = props;
  // context
  const company = useContext<Company>(CompanyContext);
  const location = useContext(LocationContext);

  // state
  const [showUpsell, setShowUpsell] = useState<boolean>(false);
  const isFeedback = location.pathname.includes('/feedback');
  const isSpambox = location.pathname.includes('/moderation');
  const hasInboxItems = typeof inboxTotalItemCount === 'number' && inboxTotalItemCount > 0;

  // helpers
  const onSpamboxClicked = () => {
    setShowUpsell(true);
  };

  const spamboxMenuItem = (
    <div className={classnames('menuItem', { active: isSpambox })}>
      <div className="left">
        <div className="itemIconContainer">
          <ClipboardCheck size={18} />
        </div>
        <p className="itemName">Moderation</p>
        {hasInboxItems && (
          <CountBadge
            className="itemCountBadge"
            variant="alert"
            size="small"
            count={inboxTotalItemCount}
          />
        )}
      </div>
      <div className="right">
        <Pill
          pillStyle={DefaultPillStyles.canny}
          className={classnames('itemBetaBadge', { minimizeBetaBadge: hasInboxItems })}>
          Beta
        </Pill>
      </div>
    </div>
  );

  return (
    <AdminSidebarSection className="adminSidebarMenuSection">
      <AdminSidebarSectionItem>
        <Link className="menuItemLink" to="/admin/feedback">
          <div className={classnames('menuItem', { active: isFeedback })}>
            <div className="left">
              <div className="itemIconContainer">
                <Inbox size={18} />
              </div>
              <p className="itemName">All Feedback</p>
            </div>
          </div>
        </Link>
      </AdminSidebarSectionItem>
      <AdminSidebarSectionItem>
        {company.features.moderationTools ? (
          <Link className="menuItemLink" to="/admin/moderation">
            {spamboxMenuItem}
          </Link>
        ) : (
          <button className="menuItemButton" onClick={onSpamboxClicked}>
            {spamboxMenuItem}
          </button>
        )}
      </AdminSidebarSectionItem>
      <UpsellModal
        feature="moderationTools"
        onClose={() => setShowUpsell(false)}
        onUpsell={() => setShowUpsell(false)}
        show={showUpsell}
      />
    </AdminSidebarSection>
  );
};

export default AdminSidebarMenuSection;
